import { render } from "./ModalWithdrawUsdtAccept.vue?vue&type=template&id=26e25e22&scoped=true&ts=true"
import script from "./ModalWithdrawUsdtAccept.vue?vue&type=script&lang=ts"
export * from "./ModalWithdrawUsdtAccept.vue?vue&type=script&lang=ts"

import "./ModalWithdrawUsdtAccept.vue?vue&type=style&index=0&id=26e25e22&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e25e22"]])

export default __exports__